module.exports = __webpack_public_path__ + "img/team2.42c61faa.jpg";